import { CustomAxiosRequestConfig, http } from '../../http';
import {
    RequestPostFavoriteFilter,
    ResponsePostFavoriteFilter,
    FavoriteFilterList,
    FavoriteFilterListResponse,
    ResponseGetFavoriteFilter,
} from './types';

import { __ } from '@/js/stores/expressions';

export const getFavoriteFiltersList = async (): Promise<FavoriteFilterList> => {
    const { data } = await http.get<FavoriteFilterListResponse>('favorite-filter/list');
    return data.favoriteFilters;
};

export const getFavoriteFilterById = async (id: string): Promise<ResponseGetFavoriteFilter> => {
    const config: CustomAxiosRequestConfig = {
        errorMessage: {
            404: __('error-404-FavoriteFilter-item', { FavoriteFilterId: id }),
        },
    };

    const { data } = await http.get<ResponseGetFavoriteFilter>(`favorite-filter/${id}`, config);
    return data;
};

export const addFavoriteFilter = async (req: RequestPostFavoriteFilter) => {
    const config: CustomAxiosRequestConfig = {
        successMessage: __('new-FavoriteFilter-success'),
    };

    const res = await http.post<ResponsePostFavoriteFilter>('favorite-filter', req, config);

    return (res as unknown as { data: ResponsePostFavoriteFilter }).data;
};

export const deleteFavoriteFilter = async (id: string): Promise<void> => {
    const config: CustomAxiosRequestConfig = {
        errorMessage: {
            404: __('delete-FavoriteFilter-error-response-404', { FavoriteFilterId: id }),
        },
        successMessage: __('delete-FavoriteFilter-success', { FavoriteFilterId: id }),
    };

    await http.delete<void>(`favorite-filter/${id}`, config);
};
